import { MultiValuedListSize } from './MultiValuedList.enums'

export const TAG_LIST_DEFAULT_SIZE = MultiValuedListSize.Small

export const TAG_LIST_DEFAULT_VISIBLE_COUNT = 1
